import {configureStore} from "@reduxjs/toolkit";
import annoncesReducer from "../slices/annoncesSlice";

const store = configureStore({
    reducer: {
        annonces: annoncesReducer
    }
})

export default store;